import { useEffect, useState } from "react";

const navLinks = [
  { id: "entries", label: "入口说明" },
  { id: "categories", label: "栏目概览" },
  { id: "guide", label: "访问指南" },
  { id: "publish", label: "发布页说明" },
  { id: "faq", label: "常见问题" },
];

export default function SiteNavbar() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled
          ? "bg-background-50/95 backdrop-blur border-b border-background-200"
          : "bg-transparent"
      }`}
    >
      <div className="mx-auto max-w-content px-4 md:px-6 h-16 flex items-center justify-between">
        <a href="#top" className="flex items-center gap-2.5 cursor-pointer" aria-label="回到顶部">
          <span className="w-9 h-9 flex items-center justify-center rounded-lg bg-primary-500 text-background-50">
            <i className="ri-movie-2-line text-lg" />
          </span>
          <span className="font-heading text-lg font-semibold text-foreground-950">
            大师兄影视
          </span>
        </a>

        <nav className="hidden md:flex items-center gap-1">
          {navLinks.map((link) => (
            <a
              key={link.id}
              href={`#${link.id}`}
              className="px-3.5 py-2 text-sm font-label text-foreground-700 hover:text-primary-700 hover:bg-primary-100/60 rounded-md transition-colors cursor-pointer whitespace-nowrap"
            >
              {link.label}
            </a>
          ))}
        </nav>

        <div className="flex items-center gap-2">
          <a
            href="#entries"
            className="hidden md:inline-flex items-center gap-1.5 px-4 py-2 text-sm font-label rounded-md bg-primary-500 text-background-50 hover:bg-primary-600 transition-colors cursor-pointer whitespace-nowrap"
          >
            <i className="ri-bookmark-3-line" />
            查看入口说明
          </a>
          <button
            type="button"
            onClick={() => setOpen((v) => !v)}
            aria-label="打开菜单"
            aria-expanded={open}
            className="md:hidden w-10 h-10 flex items-center justify-center rounded-md border border-background-300 text-foreground-800 cursor-pointer"
          >
            <i className={open ? "ri-close-line text-xl" : "ri-menu-line text-xl"} />
          </button>
        </div>
      </div>

      {open && (
        <div className="md:hidden bg-background-50 border-b border-background-200 px-4 pb-4">
          <div className="flex flex-col gap-1 pt-2">
            {navLinks.map((link) => (
              <a
                key={link.id}
                href={`#${link.id}`}
                onClick={() => setOpen(false)}
                className="text-left px-3 py-2.5 text-sm font-label text-foreground-800 hover:bg-primary-100/60 rounded-md cursor-pointer"
              >
                {link.label}
              </a>
            ))}
          </div>
        </div>
      )}
    </header>
  );
}